import { render } from "./modal-dialog.vue?vue&type=template&id=0d2074f9&scoped=true&ts=true"
import script from "./modal-dialog.vue?vue&type=script&lang=ts"
export * from "./modal-dialog.vue?vue&type=script&lang=ts"

import "./modal-dialog.vue?vue&type=style&index=0&id=0d2074f9&lang=less&scoped=true"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2074f9"]])

export default __exports__